module.exports = __webpack_public_path__ + "keyboard.598f1c02ac5865bb059b.jpg";


//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/assets/img/keyboard.jpg
// module id = ../../../../../client/assets/img/keyboard.jpg
// module chunks = styles